var _circle, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCardMainBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 423,
    height: 313,
    viewBox: "0 0 423 313",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 211,
    cy: 134.5,
    r: 121.5,
    fill: "#FFFCCA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.1528 188.388C85.9694 187.481 94.9116 184.542 128.606 175.532C170.529 164.321 202.137 177.231 213.976 182.867C243.471 196.909 259.798 186.18 280.983 183.275C292.132 181.746 231.42 234.639 164.097 250.66C139.223 256.58 48.0829 278.268 0.00293909 259.393V174.863C16.445 174.818 30.3514 190.485 69.1502 188.39L69.1528 188.388Z",
    fill: "#84C7D1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M147.403 217.433C157.856 204.305 191.587 199.706 219.336 195.924C233.209 194.033 237.814 194.123 260.629 185.884C270.629 182.275 319.265 158.178 363.301 160.703C394.396 162.484 412.267 176.368 422.767 188.481V277.344H167.372C147.926 256.29 136.71 230.861 147.403 217.433Z",
    fill: "#5BB4C2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M198.98 234.256C198.82 234.184 198.659 234.114 198.499 234.042C198.618 234.005 198.736 233.968 198.855 233.931C199.118 233.848 199.38 233.768 199.643 233.688C199.987 233.581 200.333 233.472 200.677 233.367C335.558 186.652 338.334 245.321 422.749 257.284C422.754 257.284 422.762 257.284 422.767 257.286V281.091H256.155C237.437 263.48 219.225 243.189 199.045 234.252L198.98 234.256Z",
    fill: "#66CBA4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0039657 236.148C17.524 233.906 33.2346 227.809 52.6047 223.844C115.583 210.952 156.717 224.417 181.719 230.615C219.72 240.035 381.971 241.068 422.767 276.729L422.764 312.394H0.000344191L0.00275853 229.092L0.0039657 236.148Z",
    fill: "#33B986"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardMainBackground);
export default __webpack_public_path__ + "static/media/card-main-background.5bb7fa528fd55cbc53ab2250b1e46844.svg";
export { ForwardRef as ReactComponent };